export default function () {
    return {
        emailValid: null,
        VerifyEmailResponse: null,
        user: null,
        abandonmentStatus: null,
        membershipTypes: null,
        organizationTypes: null,
        membershipLevels: null,
        countries: null,
        ofacValid: null,
        userOrgResponse: null,
        organizationList: null,
        domainsByOrganization: null,
        docusignAccessToken:null,
        docusignUserInfo:null,
        pageState: null,
        userToken: null,
        authcode: null,
        tokenStartTime: null,
        tokenStatus: null,
        Auth: {
            userRole: 'anonymous',
            user: null,
        }
    }
}